import React from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function WordBuildCard({ name, backgroundColor, onClick, isFlipping, zoom}) {
    return (
        <div
            className={`word-build-card ${isFlipping ? 'build-card-zoom-out' : ''}`}
            onClick={onClick}
            style={{
                backgroundColor: backgroundColor,
                transform: `scale(${zoom})`,
                color: backgroundColor === '#f9f9f9' ? 'black' : 'white',
                position: zoom > 1 ? 'relative' : 'initial',
            }}
        >
            {name}
        </div>
    );
}

export default WordBuildCard;
